import "../App.css";
//import "./home.css";
import moment from "moment";
import React, { useState, useEffect } from "react";
import { LoadingPage } from "../loading/LoadingPage";
import { NavigationBar } from "../navigation/NavigationBar";

import { Pagination } from "../paging/Pagination";

import { useParams, Link } from "react-router-dom";
import { call, home, addBasket } from "../service/ApiService";

import { AddBasket } from "../pay/Proxy";
import {
  Container,
  List,
  Paper,
  //Grid,
  // Button,
  // AppBar,
  // Toolbar,
  //Typography,
  ListItem,
  ListItemText,
  InputBase,
  Checkbox,
  ListItemSecondaryAction,
  IconButton,
  Button,
} from "@mui/material";

export function Item() {
  // pays?basket=402880828b0fce5b018b0fcebef80000
  const params = new URLSearchParams(window.location.search);
  let parampage = params.get("page");
  //console.log("basket :" + basket);
  //pays({ basket: basket });

  const [items, setItems] = useState([]);
  const [pages, setPages] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const size = 10;
  let limit = size;

  const [minprice, setMinprice] = useState(0);
  const [maxprice, setMaxprice] = useState(999999999);

  const [putbasket, setPutbasket] = useState(0);

  useEffect(() => {
    //effect 훅 //랜더링 후에 수행 이후  []의 오브젝트가 변경되면 수행
    call(
      "/pay/item/list?size=" +
        size +
        "&page=" +
        pages +
        "&maxprice=" +
        maxprice +
        "&minprice=" +
        minprice,
      "GET"
    ).then((response) => {
      //console.log(response);
      if (!response) {
        alert("누구냐 넌 : " + "정체를 밝혀라.");
        window.location.href = "/home";
      }

      if (response.error) {
        alert("누구냐 넌 : " + response.error);
        window.location.href = "/home";
      }

      if (response.data) {
        setItems(response.data);
        setTotalPage(Math.floor((response.data.length - 1) / size) + 1);
      }
    });
  }, []);

  /* 장애일 때 렌더링 할 부분 */
  //let loadingPage = <h1> admin.. </h1>;
  //let content = todoItems;

  /* 선택한 content 렌더링 */
  //{"welcomt Home!"}

  const onPagingClick = (item) => {
    //window.location.href = "?page=" + item;
    console.log(item + "??ㅇ");
  };

  /*
  useEffect(() => {
    //effect 훅 //랜더링 후에 수행 이후  []의 오브젝트가 변경되면 수행

    addBasket().then((response) => {
      console.log(response);
      if (response) {
        alert("장바구니 담기.");
        //반환값이 없을경우
        console.log(response.data);
        //setPutbasket(putbasket+1);
        //window.location.href = response.data;
      } else if (!response) {
        // 반환값이 없을경우
        alert("장바구니 안 담겼어요.");
        //if (window.confirm("로그인 필요합니다. 로그인 하시겠습니까?")) {
        // alert("로그인에 실패하였습니다.가입정보를 확인하여 다시 로그인 해주세요.");
        //window.location.href = "/login";
        //} else {
        //const navigate = useNavigate();
        //navigate(-1);
        // onCancel();
        //}
      } else {
        alert(" 실패.");
        //window.location.href = "/login";
      }
    });
  }, []);
  */

  let home = "Welcome Home!";

  let subject = "상품 리스트";
  let navigationBar = NavigationBar(subject);

  //<Checkbox checked={item.done} onChange={checkboxEventHandler} />

  let menu = (
    <Paper style={{ margin: 16 }}>
      <List className="menu">
        <div>{"Menu"}</div>
        <ListItem>
          <Link to="/home" variant="1">
            상위단계 home
          </Link>
          <ListItemText></ListItemText>
          <ListItemSecondaryAction>상위 단계로 이동.</ListItemSecondaryAction>
        </ListItem>
      </List>
    </Paper>
  );

  items.map((item) => {
    if (moment(item.createdAt).isValid()) {
      item.createdAt = moment(item.createdAt).format("YYYY-MM-DD");
    } else {
      //item.createdAt = moment().format("YYYY-MM-DD");
      item.createdAt = moment("2000-01-01", "YYYY-MM-DD").format("YYYY-MM-DD");
    }
  });

  let todoItems = items.length > 0 && (
    <div>
      <Paper style={{ margin: 16 }}>
        <List className="menu">
          <div>
            <table>
              <thead></thead>
              <tbody>
                <tr>
                  <th>카테고리</th>
                  <th>타입</th>
                  <th>아이템</th>
                  <th>가격</th>
                  <th>마감일</th>
                  <th>상세보기</th>
                </tr>
                {items.map((item) => (
                  <tr item={item} key={item.id}>
                    <td>
                      {""}
                      {item.category}
                    </td>
                    <td>
                      {""}
                      {item.type}
                    </td>
                    <td>
                      {""}
                      {item.itemName}
                    </td>
                    <td>
                      {""}
                      {item.price}
                    </td>
                    <td>
                      {""}
                      {item.createdAt}
                    </td>
                    <td>
                      {/* onClick={()=>{onPagingClick(item.id)}} */}
                      <Link
                        to={
                          "/viewItem?item=" + item.id + "&page=" + pages /* */
                        }
                        variant="1"
                      >
                        <Button>{"아이템 보기 "}</Button>
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </List>
      </Paper>
    </div>
  );

  let paging = Pagination({ totalPage, limit, pages, setPages });
  if (items.length == 0) {
    paging = <div>없음.</div>;
  }
  /*
  let todoItems = items.length > 0 && (
    <Paper style={{ margin: 16 }}>
      <List>
        {items.map((item) => (
          <div item={item} key={item.id}>
            {item.id}
            {" -- "}
            {item.username}
          </div>
        ))}
      </List>
    </Paper>
  );

  */

  let content;
  /* 로딩중이 아닐 때 렌더링 할 부분 */
  let framePage = (
    <div>
      {navigationBar} {/* 네비게이션 바 렌더링 */}
      <Container maxWidth="md">{menu}</Container>
      <Container maxWidth="md">{todoItems}</Container>
      <Container maxWidth="md">{paging}</Container>
    </div>
  );

  content = framePage;
  return <div className="App">{content}</div>;
}
